var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReeveHeaderLineTopRight = function SvgReeveHeaderLineTopRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 243,
    height: 1155,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000B31",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M243 1153.94h-89.416c-11.422 0-20.681-8.25-20.681-18.44l-.001-373.121c0-10.181-8.911-18.435-19.902-18.435H21.681C10.26 743.944 1 735.686 1 725.501V302.392C1 292.235 10.26 284 21.68 284H94c11.422 0 19.902-8.258 19.902-18.443V20.213c0-10.157 9.26-18.392 20.68-18.392h112.32"
  })));
};
export default SvgReeveHeaderLineTopRight;